import * as React from 'react';
import { SVGProps } from 'react';

const IconHandSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 1a.8.8 0 0 0-.8.8v5.7h-.7V3.25a.75.75 0 0 0-1.5 0v5.923L3.878 8.047a1.056 1.056 0 0 0-1.556 0 1.217 1.217 0 0 0 0 1.65l3.52 3.732C6.582 14.388 7.706 15 8.966 15 11.194 15 13 13.084 13 10.722V8.5h.002V4.25a.75.75 0 1 0-1.5 0V7.5H11V2.742a.75.75 0 0 0-1.5 0V7.5h-.7V1.8A.8.8 0 0 0 8 1z" />
  </svg>
);
export default IconHandSizeS;
